import { Link } from "react-router-dom";
import { truncate } from "../../lib/text";

/**
 * Poster grid shared by the category page and search results.
 * `linkTo` decides each tile's destination.
 */
const PosterGrid = ({ items, linkTo }) => (
  <div className="grid grid-cols-2 gap-x-2 gap-y-8 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7">
    {items.map((item) => (
      <Link key={`${item.type}-${item.id}`} to={linkTo(item)}>
        <div className="relative cursor-pointer text-white">
          <div className="h-[256px] w-[180px]">
            <img
              src={item.cover}
              className="h-full w-full rounded-md object-cover"
              alt={item.name}
              loading="lazy"
            />
          </div>
          <h2 className="mr-2 mt-1 text-base font-normal leading-6">
            {truncate(item.name, 32)}
          </h2>
        </div>
      </Link>
    ))}
  </div>
);

export default PosterGrid;
